module.exports = __webpack_public_path__ + "img/石斛.7522748b.jpg";